import React from "react";
import { OcRoleFilterSwitchItemView } from "./role-filter-switch-item-view";
import { useOcRoleFilterSwitchItem } from "./use-role-filter-switch-item";

export interface OcRoleFilterSwitchItemProps {
  label: string;
  selected: boolean;
  disabled?: boolean;
  handleSwitchChange: () => void;
}

export const OcRoleFilterSwitchItem: React.FC<OcRoleFilterSwitchItemProps> = ({
  label,
  selected,
  disabled,
  handleSwitchChange,
}) => {
  const { translatedLabel } = useOcRoleFilterSwitchItem({
    label,
  });
  return (
    <OcRoleFilterSwitchItemView
      handleSwitchChange={handleSwitchChange}
      label={translatedLabel}
      selected={selected}
      disabled={disabled}
    />
  );
};
